import { render, staticRenderFns } from "./Clv--SVG.vue?vue&type=template&id=8847ba26&lang=pug&"
import script from "./Clv--SVG.vue?vue&type=script&lang=js&"
export * from "./Clv--SVG.vue?vue&type=script&lang=js&"
import style0 from "./Clv--SVG.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports